import { Box } from '@mui/material';
import React, { useState } from 'react';

type SetTabLoading = React.Dispatch<React.SetStateAction<boolean>>;
type SetActiveTab = React.Dispatch<React.SetStateAction<number>>;
type SetValue = React.Dispatch<React.SetStateAction<number>>;

type Column1Props = {
  setTabLoading: SetTabLoading;
  setActiveTab: SetActiveTab;
  channelID?: string;
};

type Column2Props = {
  setTabLoading: SetTabLoading;
  setActiveTab: SetActiveTab;
  setValue?: SetValue;
};

type Column3Props = {
  setTabLoading: SetTabLoading;
  path?: string;
};

type AlternateColumn3Props = {
  setTabLoading: SetTabLoading;
  creatorInfo?: any;
  setValue?: any;
  captive8Url?: any;
  captive8loading?: boolean;
};

type Column4Props = {
  setValue?: SetValue;
};

type DoubleColumnProps = {
  setTabLoading: SetTabLoading;
  setActiveTab: SetActiveTab;
  setValue?: SetValue;
  path?: string;
  channelID?: string;
};

const OverviewTab = ({
  setActiveTab,
  Column1,
  Column2,
  Column3,
  Column4,
  creatorInfo,
  AlternatColumn3,
  setValue,
  captive8Url,
  captive8Loading,
  path,
  channelID,
  DoubleColumnComponent,
}: {
  setActiveTab: SetActiveTab;
  creatorInfo?: any;
  channelID?: string;
  Column1: React.ComponentType<Column1Props>;
  Column2: React.ComponentType<Column2Props>;
  Column3: React.ComponentType<Column3Props>;
  AlternatColumn3?: React.ComponentType<AlternateColumn3Props>;
  Column4: React.ComponentType<Column4Props>;
  setValue?: SetValue;
  captive8Url?: any;
  captive8Loading?: boolean;
  path?: string;
  DoubleColumnComponent?: React.ComponentType<DoubleColumnProps>;
}) => {
  const [, setLoading] = useState(true);

  const rightColumn = (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        width: 'calc(33.333% - 27px)',
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {(creatorInfo || captive8Url || captive8Loading) && AlternatColumn3 && setValue ? (
          <AlternatColumn3
            captive8loading={captive8Loading}
            setTabLoading={setLoading}
            creatorInfo={creatorInfo}
            setValue={setValue}
            captive8Url={captive8Url}
          />
        ) : (
          <Column3 setTabLoading={setLoading} path={path || ''} />
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Column4 setValue={setValue} />
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '20px', xl: '32px' },
        width: '100%',
        flex: 1,
      }}
    >
      {DoubleColumnComponent ? (
        <>
          <Box
            sx={{
              flex: 2,
              display: 'flex',
              flexDirection: 'column',
              minWidth: 0,
              gap: '24px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: { xs: '20px', xl: '32px' },
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  minWidth: 0,
                }}
              >
                <Column1
                  setActiveTab={setActiveTab}
                  setTabLoading={setLoading}
                  channelID={channelID}
                />
              </Box>

              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  minWidth: 0,
                }}
              >
                <Column2
                  setActiveTab={setActiveTab}
                  setTabLoading={setLoading}
                  setValue={setValue}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: 0,
                flex: 1,
              }}
            >
              <DoubleColumnComponent
                setActiveTab={setActiveTab}
                setTabLoading={setLoading}
                setValue={setValue}
                path={path}
                channelID={channelID}
              />
            </Box>
          </Box>

          {rightColumn}
        </>
      ) : (
        <>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              width: 'calc(33.333% - 27px)',
            }}
          >
            <Column1 setActiveTab={setActiveTab} setTabLoading={setLoading} channelID={channelID} />
          </Box>

          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              width: 'calc(33.333% - 27px)',
            }}
          >
            <Column2 setActiveTab={setActiveTab} setTabLoading={setLoading} setValue={setValue} />
          </Box>

          {rightColumn}
        </>
      )}
    </Box>
  );
};

export default OverviewTab;
